import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_BaseBtModal = _resolveComponent("BaseBtModal");
  return _openBlock(), _createBlock(_component_BaseBtModal, {
    id: "email-confirm-modal",
    "data-cy": "email-confirm-modal",
    "show-modal": _ctx.showModal,
    "header-title": _ctx.labels.title,
    size: "modal-md",
    "custom-modal-header-classes": "!tw-px-15px sm:!tw-px-25px lg:!tw-pt-30px",
    "custom-modal-body-classes": "!tw-py-15px",
    onClosed: _ctx.onClosed,
    onOpened: _ctx.onOpened
  }, {
    body: _withCtx(function () {
      return [_createElementVNode("p", {
        innerHTML: _ctx.labels.confirmation_mail_sent
      }, null, 8 /* PROPS */, _hoisted_1)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-modal", "header-title", "onClosed", "onOpened"]);
}